/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Manage_AccountsInputs */



/**
* | output |
* | --- |
* | "Manage accounts" |
*
* @param {Menu_Manage_AccountsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const menu_manage_accounts = /** @type {((inputs?: Menu_Manage_AccountsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Manage_AccountsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление аккаунтами")
	return /** @type {LocalizedString} */ ("Manage accounts")
});